export const getOutlookMobileRefreshedPlacementStyles = () => {
  const styles = {
    outlookWebCardRoot: {
      margin: 'auto',
      width: '100%',
      height: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      overflowX: 'auto',
    },

    placementCard: {
      width: 375,
      height: 85,
      padding: '10px 16px 10px 0px',
      display: 'flex',
      alignItems: 'center',
      cursor: 'pointer',

      '& .placement-card-content': {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        height: '100%',
      },

      '&:hover': {
        backgroundColor: 'rgba(245, 245, 245, 1)',
      },
    },

    unreadClassName: {
      margin: '0px 4px',
      height: 8,
      width: 8,
    },

    placementTextContainer: {
      display: 'block',
      position: 'relative',
      height: '100%',
      width: 293,
    },

    adsLabelClassName: {
      position: 'absolute',
      right: 26,
      top: 3,
      width: 24,
      height: '18px !important',
      borderRadius: '2px !important',
      border: '1px solid rgba(0, 120, 212, 1) !important',
      padding: '0px 4px !important',
      boxSizing: 'border-box !important',
      textAlign: 'center !important',
      fontWeight: '400 !important',
      fontSize: '12px !important',
      lineHeight: '16px !important',
      color: 'rgba(0, 120, 212, 1) !important',
    },

    threeDot: {
      position: 'absolute',
      right: 0,
      top: 3,
    },

    placementBusinessNameWithAdsLabel: {
      fontFamily: 'Segoe UI',
      fontWeight: '600',
      fontSize: '16px',
      lineHeight: '24px',
    },

    placementShortHeadline: {
      fontFamily: 'Segoe UI',
      fontSize: 14,
      fontWeight: 600,
      lineHeight: '20px',
      color: 'rgba(15, 108, 189, 1)',
    },

    descriptionWithAction: {
      display: 'flex',
      flexWrap: 'nowrap',
      alignItems: 'center',
    },

    placementCallToAction: {
      flexShrink: 0,
      height: '24px',
      borderRadius: '4px',
      border: '1px solid rgba(209, 209, 209, 1)',
      backgroundColor: 'transparent',
      padding: '0px 8px',
      fontFamily: 'Segoe UI',
      fontWeight: 400,
      fontSize: 12,
      lineHeight: '22px',
      color: 'rgba(36, 36, 36, 1)',
      marginLeft: '4px',
      boxSizing: 'border-box',
    },

    placementDescription: {
      color: 'rgba(97, 97, 97, 1)',
      fontSize: 14,
      lineHeight: '20px',
      fontFamily: 'Segoe UI',
      fontWeight: 400,
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      flexGrow: 1,
    },

    placementLogoContainer: {
      width: 38,
      marginRight: 13,
      '& .cropped-image-view': {
        borderRadius: '50% !important',
      },
    },
  };
  return styles;
};

export const getOutlookWebRefreshedPlacementStyles = () => {
  const styles = {
    outlookWebCardRoot: {
      margin: 'auto',
      width: '100%',
      height: '100%',
      display: 'flex',
      alignItems: 'center',
      overflowX: 'auto',
    },

    placementCard: {
      width: 1089,
      height: 36,
      borderRadius: 0,
      display: 'flex',
      flexDirection: 'row',
      flexShrink: 0,
      alignItems: 'center',
      backgroundColor: 'white',
      borderBottom: '1px solid var(--Neutral-colors-neutralLight, rgba(240, 240, 240, 1))',
      boxShadow: '0px -1px 0px 0px rgba(240, 240, 240, 1) inset',
      paddingRight: 28,
      boxSizing: 'border-box',

      '& .placement-card-content': {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        height: '100%',
        flexGrow: 1,
      },
    },

    unreadClassName: {
      display: 'flex',
      alignItems: 'center',
      height: '100%',
      width: 28,
      '& .unread-flag': {
        height: '100%',
        width: '4px',
        backgroundColor: 'rgba(15, 108, 189, 1)',
        content: '',
        display: 'block',
      },

      '& .unread-arrow': {
        width: 16,
        height: 16,
        marginLeft: 2,
      },
    },

    placementTextContainer: {
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      height: '100%',
      flexGrow: 1,
      padding: '8px 4px 8px 8px',
      boxSizing: 'border-box',

      '& .logo-and-businessname-container': {
        display: 'inline-block',
        position: 'relative',
      },
    },

    adsLabelClassName: {
      position: 'absolute',
      left: 176,
      top: 9,
      width: 24,
      height: '18px !important',
      border: '1px solid rgba(0, 120, 212, 1) !important',
      padding: '0px 4px !important',
      boxSizing: 'border-box !important',
      textAlign: 'center !important',
      borderRadius: '2px !important',
      fontWeight: '400 !important',
      fontSize: '12px !important',
      lineHeight: '16px !important',
      color: 'rgba(0, 120, 212, 1) !important',
    },

    threeDot: {
      position: 'absolute',
      left: 208,
      top: 9,
    },

    placementBusinessNameWithAdsLabel: {
      width: 224,
      marginRight: 16,
    },

    placementShortHeadline: {
      marginRight: 8,
      fontFamily: 'Segoe UI',
      fontWeight: '600',
      fontSize: '14px',
      lineHeight: '20px',
      color: 'rgba(15, 108, 189, 1)',
    },

    placementDescription: {
      fontFamily: 'Segoe UI',
      fontWeight: 400,
      fontSize: '14px',
      lineHeight: '20px',
      color: 'rgba(97, 97, 97, 1)',
    },

    placementLogoContainer: {
      width: 28,
      '& .cropped-image-view': {
        borderRadius: '50% !important',
      },
    },
  };
  return styles;
};
